module.exports = __webpack_public_path__ + "img/gc1.30ff3c86.png";